<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Alojamiento Especializado</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Alojamiento Especializado</li>
                    </ul>
                </div>
            </div>


            <div class="special-intro-offer-wrap">
                <div class="row">
                    <h4 style="color: #FFF;">Características</h4>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-rocket"></i>
                            <h3>Optimización para Aplicaciones Específicas</h3>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-gauge-high"></i>
                            <h3>Alto Rendimiento y Escalabilidad</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-lock"></i>
                            <h3>Seguridad Avanzada y Cumplimiento Normativo</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-headset"></i>
                            <h3>Soporte Técnico Especializado 24/7</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-earth-americas"></i>
                            <h3>Disponibilidad y Alta Confiabilidad</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-gears"></i>
                            <h3>Flexibilidad y Planes Personalizados</h3>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center">¿Qué es un Alojamiento Especializado?</h2>

                    <p class="text-justify">
                        El Alojamiento Especializado de enCloud es un servicio optimizado para sitios web, aplicaciones y plataformas que requieren alto rendimiento, seguridad y configuraciones personalizadas.
                        A diferencia del Cómputo en la Nube, donde los clientes gestionan su
                        infraestructura de manera
                        flexible, el alojamiento especializado está diseñado para casos de uso específicos, con
                        configuraciones predefinidas y soporte técnico especializado.
                    </p>
                    <p class="text-justify">
                        Si necesitas una solución lista para usar y adaptada a tu negocio, nuestro alojamiento especializado te brinda la estabilidad y el soporte que requieres.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="domain-pricing-list-area pt-70">
    <div class="container">
        <div class="row">


            <div class="col-lg-12 col-md-12">
                <h2 class="custom-table-title">Diferencias entre Alojamiento Especializado y Cómputo en la Nube</h2>

                <div class="custom-table ">
                    <table class="table">
                        <thead>
                            <tr>

                                <th scope="col">Característica</th>
                                <th scope="col">Alojamiento Especializado </th>
                                <th scope="col">Cómputo en la Nube</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">
                                    Gestión
                                </td>

                                <td class="special">
                                    Administrado por enCloud
                                </td>
                                <td class="special">
                                    Gestionado por el cliente
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Optimización
                                </td>

                                <td class="special">
                                    Configurado para casos de uso específicos
                                </td>
                                <td class="special">
                                    Infraestructura flexible y escalable
                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Casos de uso
                                </td>

                                <td class="special">
                                    Sitios web, ecommerce, gaming, apps empresariales, etc.
                                </td>
                                <td class="special">
                                    Máquinas virtuales, contenedores, Big Data, IA, etc.

                                </td>
                            </tr>
                            <tr>
                                <td scope="row">
                                    Facilidad de uso
                                </td>

                                <td class="special">
                                    Solución lista para usar con soporte técnico
                                </td>
                                <td class="special">
                                    Requiere configuración personalizada

                                </td>
                            </tr>

                            <tr>
                                <td scope="row">
                                    Seguridad
                                </td>

                                <td class="special">
                                    Incluye protección avanzada, backups y monitoreo </td>
                                <td class="special">
                                    Personalizable según la configuración del cliente
                                </td>
                            </tr>


                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</section>




<section class="customer-support-area pt-70">

    <div class="container">
        <h1 class="text-center">Tipos de Alojamiento Especializado </h1>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-cart-shopping"></i>
                            <h3>Para Comercio Electrónico (E-commerce Hosting)</h3>
                            <div class="row">
                                <a>🔹 Optimizado para tiendas en línea con Magento, WooCommerce, Shopify, PrestaShop y
                                    más.</a>
                                <a>🔹 Alta velocidad y tiempos de carga optimizados para mejorar el SEO.</a>
                                <a>🔹 DDoS y certificados SSL para transacciones seguras.</a>
                                <a>🔹 Integración con pasarelas de pago y gestión de inventario.</a>

                                <p class="example"> <strong>Ejemplo de uso:</strong> Un marketplace con miles de
                                    visitantes necesita
                                    alojamiento de alto rendimiento para evitar caídas y mejorar la experiencia del
                                    usuario.
                                </p>

                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-briefcase"></i>
                            <h3>Para Aplicaciones Empresariales</h3>
                            <div class="row">
                                <a>🔹 Diseñado para ERP, CRM, bases de datos y aplicaciones SaaS.</a>
                                <a>🔹 Alta disponibilidad y redundancia para minimizar el tiempo de inactividad.</a>
                                <a>🔹 Escalabilidad automática para adaptarse al crecimiento del negocio.</a>
                                <a>🔹 Soporte para bases de datos SQL y NoSQL con respaldo automático.</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Una empresa que usa SAP necesita
                                    alojamiento
                                    especializado para garantizar el acceso continuo a sus sistemas.</p>

                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-diamond"></i>
                            <h3>Para Inteligencia Artificial y Big Data</h3>
                            <div class="row">
                                <a>🔹 Infraestructura optimizada para Machine Learning, análisis de datos y
                                    procesamiento
                                    en paralelo.</a>
                                <a>🔹 Soporte para TensorFlow, PyTorch, Apache Spark, Hadoop y más.</a>
                                <a>🔹 Almacenamiento de alto rendimiento para grandes volúmenes de datos.</a>
                                <a>🔹 Escalabilidad automática para cargas de trabajo intensivas.</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Un centro de investigación usa
                                    alojamiento especializado
                                    para entrenar modelos de IA con grandes volúmenes de datos.</p>

                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-photo-film"></i>
                            <h3>Para Contenido Multimedia (Streaming & Media Hosting)</h3>
                            <div class="row">
                                <a>🔹 Optimizado para transmisión de video, podcasts y plataformas de streaming.</a>
                                <a>🔹 CDN integrado para distribución de contenido sin interrupciones.</a>
                                <a>🔹 Ancho de banda escalable para transmisiones en vivo sin latencia.</a>
                                <a>🔹 Soporte para formatos de video en alta calidad (HD, 4K).</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Un servicio de streaming de eventos
                                    en vivo necesita
                                    un alojamiento con alta velocidad y baja latencia para garantizar una transmisión
                                    fluida.</p>

                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-blender-phone"></i>
                            <h3>Para IoT y Dispositivos Conectados</h3>
                            <div class="row">
                                <a>🔹 Especializado en infraestructura para dispositivos inteligentes, sensores y
                                    telemetría.</a>
                                <a>🔹 Baja latencia y conectividad global para manejar datos en tiempo real.</a>
                                <a>🔹 Soporte para protocolos IoT como MQTT, CoAP y HTTP.</a>
                                <a>🔹 Seguridad reforzada para proteger dispositivos contra ataques.</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Una empresa de domótica necesita
                                    alojamiento
                                    especializado para gestionar miles de dispositivos conectados en distintos hogares.
                                </p>

                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-hospital"></i>
                            <h3>Para el Sector Salud</h3>
                            <div class="row">
                                <a>🔹 Cumple con normativas de seguridad y privacidad (HIPAA, GDPR).</a>
                                <a>🔹 Infraestructura de alta disponibilidad para registros médicos electrónicos.</a>
                                <a>🔹 Soporte para integración con sistemas hospitalarios.</a>
                                <a>🔹 Protección avanzada contra accesos no autorizados.</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Un hospital necesita alojamiento
                                    especializado para
                                    almacenar y acceder a expedientes médicos digitales en cualquier momento.</p>

                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-building-columns"></i>
                            <h3>Para Gobiernos e Instituciones Públicas</h3>
                            <div class="row">
                                <a>🔹 Máxima seguridad y cumplimiento de normativas de datos gubernamentales.</a>
                                <a>🔹 Alta disponibilidad y escalabilidad para portales ciudadanos.</a>
                                <a>🔹 Centros de datos en México con soberanía sobre los datos.</a>
                                <a>🔹 Soporte 24/7 con expertos en seguridad.</a>

                                <p class="example"><strong>Ejemplo de uso:</strong> Un portal de trámites
                                    gubernamentales necesita
                                    alojamiento con máxima seguridad y disponibilidad para atender a millones de
                                    ciudadanos.
                                </p>

                            </div>
                        </li>


                    </ul>
                </div>
            </div>
        </div>


    </div>
</section>


<section class="pricing-area pt-100">
    <div class="container">
        <div class="section-title">
            <h2>📦 Paquetes de Alojamiento Especializado</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete PYMEs</h3>
                        <p>Para pequeñas empresas y startups</p>
                    </div>
                    <!-- <span>$29.00 <sub>/Month</sub></span> -->
                    <div class="custom-price-panel">
                        <span>Software incluido:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> Gestión de correos y calendarios (Mailcow o Zimbra)</li>
                            <li><i class="flaticon-tick"></i> Almacenamiento y compartición de archivos (Nextcloud)</li>
                            <li><i class="flaticon-tick"></i> Chat Empresarial (Rocket.Chat o Mattermost)</li>
                            <li><i class="flaticon-tick"></i> Gestión de Clientes (Odoo CRM o ERPNext) </li>
                            <li><i class="flaticon-tick"></i> Gestión de Proyectos (Redmine o Taiga) </li>
                        </ul>
                    </div>

                </div>

            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete Empresas Medianas </h3>
                        <p>Para negocios en expansión</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Software incluido:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> Lo ofrecido en el paquete PYMEs</li>
                            <li><i class="flaticon-tick"></i> Automatización y DevOps (Jenkins y/o GitLab CI/CD)</li>
                            <li><i class="flaticon-tick"></i> Monitoreo de Infraestructura (Prometheus y Grafana) </li>
                            <li><i class="flaticon-tick"></i> Helpdesk y Soporte (Zammad o osTicket)</li>
                            <li><i class="flaticon-tick"></i> Seguridad y Respaldo (Vaultwarden)</li>
                            <li><i class="flaticon-tick"></i> Colaboración y Documentación (Wiki.js o OnlyOffice) </li>
                        </ul>
                    </div>

                </div>
                <!-- <span class="popular">Popular</span> -->
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete Personalizado</h3>
                        <p>Para necesidades específicas</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Software incluido:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> ERP y Gestión Empresarial (ERPNext y Odoo)</li>
                            <li><i class="flaticon-tick"></i> Chat y Videollamadas Privadas (Matrix y Element)</li>
                            <li><i class="flaticon-tick"></i> Bases de Datos (MSSQL, PostgreSQL, MariaDB o MongoDB)</li>
                            <li><i class="flaticon-tick"></i> Plataforma de Recursos Humanos (OrangeHRM o OpenProject)
                            </li>
                            <li><i class="flaticon-tick"></i> Automatización de Procesos (Camunda BPM o ProcessMaker)
                            </li>
                            <li><i class="flaticon-tick"></i> Analítica y Big Data (Metabase, Apache Superset o Airflow)
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>


<app-vs-others></app-vs-others>

<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>

<app-clients [pt]="pt" [pb]="pb"></app-clients>